import { PromptTemplateVarInputType } from "../../../api"
import { FileVarElementFactory } from "./FileVarElementFactory"
import { PullDownVarElementFactory } from "./PullDownVarElementFactory";
import { TextVarElementFactory } from "./TextVarElementFactory"
import { TranscribeFileVarElementFactory } from "./TranscribeFileVarElementFactory";

export const factories = [
    TextVarElementFactory,
    PullDownVarElementFactory,
    FileVarElementFactory,
    TranscribeFileVarElementFactory
]

export const getFactory = (inputType: string) => {
    for (const factory of factories) {
        if (factory.inputType === inputType) return factory 
    }
}

export const getUndroppableInputTypes = () => {
    return factories.filter((f) => !f.isDroppableToRequest).map((f) => f.inputType)
}